import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { format, nextMonday, nextThursday } from 'date-fns';
import { Subject, takeUntil } from 'rxjs';
import { isValueInArrayValidator } from 'src/app/libs/ui/utils/input-validators.utils';
import { FindTripFormGroupInterface } from '../../../data-access/models/interface/find-trip-form.interface';
import { FormsMetadata } from '../../../data-access/models/consts/find-trip-form.const';

@Component({
  selector: 'tic-find-trip-form',
  templateUrl: './find-trip-form.component.html',
  styleUrls: ['./find-trip-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class FindTripFormComponent implements OnInit, OnDestroy {
  @Output() onSubmitDetails: EventEmitter<FindTripFormGroupInterface> = new EventEmitter();
  readonly formsMetadata = FormsMetadata;
  inboundDate = new FormControl('');
  outboundDate = new FormControl('');
  datesFormGroup = new FormGroup({
    inboundDate: this.inboundDate,
    outboundDate: this.outboundDate,
  });

  originLocationCodeFormControl = new FormControl(this.formsMetadata['origin'].defaultValue());
  destinationLocationCodeFormControl = new FormControl(this.formsMetadata['destination'].defaultValue());
  numberOfAdultsFormControl = new FormControl(this.formsMetadata['numberOfAdults'].defaultValue());
  paxesChildrenAgesFormControl = new FormControl();
  numberOfChildrenFormControl = new FormControl(this.formsMetadata['numberOfChildren'].defaultValue());
  numberOfRoomsFormControl = new FormControl(this.formsMetadata['numberOfRooms'].defaultValue());

  findTripFormGroup = new FormGroup({
    destinationLocationCode: this.destinationLocationCodeFormControl,
    numberOfAdults: this.numberOfAdultsFormControl,
    numberOfChildren: this.numberOfChildrenFormControl,
    paxesChildrenAges: this.paxesChildrenAgesFormControl,
    numberOfRooms: this.numberOfRoomsFormControl,
    originLocationCode: this.originLocationCodeFormControl,
  });
  formArray = new FormArray([this.findTripFormGroup, this.datesFormGroup]);
  wholeFormDetails!: FindTripFormGroupInterface;
  private destroy$: Subject<unknown> = new Subject();
  readonly isValueInArrayValidator = isValueInArrayValidator;

  constructor() {}

  ngOnInit(): void {
    this.initFormGroupSubscriber();
    this.initDatesForm();
  }

  private initDatesForm(): void {
    const startDate = nextThursday(new Date());
    const endDate = nextMonday(startDate);
    this.datesFormGroup.setValue({
      inboundDate: format(startDate, 'yyyy-MM-dd'),
      outboundDate: format(endDate, 'yyyy-MM-dd'),
    });
  }

  private initFormGroupSubscriber(): void {
    this.formArray.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((data) => { // TODO: should add type
      data.forEach(item => this.wholeFormDetails = { 
        ...this.wholeFormDetails, 
        ...item,
      });
    });
  }
  
  onSubmit(): void {
    this.wholeFormDetails = {
      ...this.wholeFormDetails,
      numberOfAdults: this.numberOfAdultsFormControl.value,
      numberOfChildren: this.numberOfChildrenFormControl.value,
    }
    
    this.onSubmitDetails.emit(this.wholeFormDetails);
  }
  
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
